import { render, staticRenderFns } from "./Tarif.vue?vue&type=template&id=5a000eea&scoped=true&lang=html&"
import script from "./Tarif.vue?vue&type=script&lang=js&"
export * from "./Tarif.vue?vue&type=script&lang=js&"
import style0 from "./Tarif.vue?vue&type=style&index=0&id=5a000eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a000eea",
  null
  
)

export default component.exports